import { SVGProps, Ref, forwardRef } from 'react'
const SvgPersonSimple = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1.5rem"
    height="1.5rem"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M6.75 6a5.25 5.25 0 1 0 10.5 0 5.25 5.25 0 0 0-10.5 0v0ZM2.25 23.25a9.75 9.75 0 1 1 19.5 0"
    />
  </svg>
)
const ForwardRef = forwardRef(SvgPersonSimple)
export default ForwardRef
